import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { usePortalAppearance, useSetPortalAppearance } from './portalAppearanceContext';

/** Schmaler Schalter unter dem Wappen. Mond links, Sonne rechts, Punkt wandert. */
export const PortalAppearanceSwitch: React.FC<{ className?: string }> = ({ className = '' }) => {
  const appearance = usePortalAppearance();
  const setAppearance = useSetPortalAppearance();
  const light = appearance === 'light';
  const icon = 'h-3.5 w-3.5 shrink-0';

  return (
    <div className={`inline-flex items-center gap-1 ${className}`}>
      <Moon
        className={`${icon} ${light ? 'text-[#6a5684]' : 'text-violet-200'}`}
        strokeWidth={1.75}
        aria-hidden
      />
      <button
        type="button"
        role="switch"
        aria-checked={light}
        aria-label={light ? 'Helles Template, umschalten auf dunkel' : 'Dunkles Template, umschalten auf hell'}
        data-testid="portal-appearance-switch"
        onClick={() => setAppearance(light ? 'dark' : 'light')}
        className={`relative inline-flex h-[18px] w-[34px] shrink-0 items-center rounded-full border p-0.5 transition-colors focus:outline-none focus-visible:ring-1 focus-visible:ring-violet-400/50 ${
          light ? 'border-[#6a5684] bg-[#ddd4ea]' : 'border-violet-400/30 bg-[#07070a]'
        }`}
      >
        <span
          aria-hidden
          className={`pointer-events-none block h-3 w-3 rounded-full transition-transform ${
            light ? 'translate-x-[16px] bg-[#5b4678]' : 'translate-x-0 bg-violet-300'
          }`}
        />
      </button>
      <Sun
        className={`${icon} ${light ? 'text-[#5b4678]' : 'text-violet-300/80'}`}
        strokeWidth={1.75}
        aria-hidden
      />
    </div>
  );
};
